<app-admin-page-header
  eyebrow="Communauté"
  title="Newsletter"
  subtitle="Liste des adresses email collectées via le formulaire d'inscription à la newsletter.">
  <button (click)="copyAll()" type="button"
    class="inline-flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 text-gray-700 text-sm font-raleway font-semibold rounded-lg hover:bg-gray-50 transition-colors">
    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"/>
    </svg>
    {{ copied ? 'Copié !' : 'Copier tout' }}
  </button>
  <button (click)="exportCsv()" type="button"
    class="inline-flex items-center gap-2 px-4 py-2 bg-primary text-white text-sm font-raleway font-semibold rounded-lg hover:bg-secondary transition-colors shadow-sm">
    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5 5-5M12 15V3"/>
    </svg>
    Exporter en CSV
  </button>
</app-admin-page-header>

<!-- Stats -->
<div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
  <div class="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
    <p class="text-xs uppercase tracking-wider font-semibold text-gray-400">Inscrits</p>
    <p class="text-3xl font-alice text-blue-dark mt-1">{{ emails.length }}</p>
    <p class="text-xs text-gray-500 mt-1">Adresses collectées</p>
  </div>
  <div class="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
    <p class="text-xs uppercase tracking-wider font-semibold text-gray-400">Domaines uniques</p>
    <p class="text-3xl font-alice text-blue-dark mt-1">{{ domainsCount }}</p>
    <div class="flex flex-wrap gap-1 mt-3">
      @for (d of topDomains; track d) {
        <span class="text-[10px] font-raleway bg-gray-100 text-gray-700 px-2 py-1 rounded-full">
          {{ d.domain }} <span class="text-gray-400">· {{ d.count }}</span>
        </span>
      }
    </div>
  </div>
  <div class="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
    <p class="text-xs uppercase tracking-wider font-semibold text-gray-400">Filtre actif</p>
    <p class="text-3xl font-alice text-blue-dark mt-1">{{ filteredEmails.length }}</p>
    <p class="text-xs text-gray-500 mt-1">Résultats affichés</p>
  </div>
</div>

<!-- Search + list -->
<div class="bg-white rounded-xl border border-gray-200 shadow-sm">
  <div class="px-5 py-4 border-b border-gray-100">
    <div class="relative max-w-md">
      <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
        <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
        </svg>
      </div>
      <input type="search" [(ngModel)]="search" placeholder="Rechercher un email ou un domaine..."
        class="w-full pl-10 pr-3 py-2 text-sm font-raleway bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary">
      </div>
    </div>

    <div class="overflow-x-auto">
      <table class="w-full text-sm font-raleway">
        <thead class="bg-gray-50">
          <tr>
            <th class="text-left px-5 py-3 text-[11px] uppercase tracking-wider font-semibold text-gray-500">Email</th>
            <th class="text-left px-5 py-3 text-[11px] uppercase tracking-wider font-semibold text-gray-500">Domaine</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100">
          @for (email of filteredEmails; track email) {
            <tr class="hover:bg-gray-50 transition-colors">
              <td class="px-5 py-3 text-gray-800">{{ email }}</td>
              <td class="px-5 py-3 text-gray-500">{{ domainOf(email) }}</td>
            </tr>
          }
          @if (!loading && filteredEmails.length === 0) {
            <tr>
              <td colspan="2" class="px-5 py-10 text-center text-sm text-gray-400">
                @if (search) {
                  <span>Aucun email ne correspond à « {{ search }} ».</span>
                }
                @if (!search) {
                  <span>Aucune adresse pour l'instant.</span>
                }
              </td>
            </tr>
          }
          @if (loading) {
            <tr>
              <td colspan="2" class="px-5 py-10 text-center text-sm text-gray-400">Chargement…</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
